import external from '../../external'
import Papa from 'papaparse'

// initial state
const state = {
  status: '',
  siteInfo: '',
  termsOfService: '',
  maintenanceCSV: '',
  areaInfoCSV: '',
  historyMaintenanceCSV: '',
  footerLinkCSV: [],
  error: ''
}

// getters
const getters = {
  error: state => state.error,
  siteInfo: state => state.siteInfo,
  areaInfoCSV: state => state.areaInfoCSV,
  maintenanceCSV: state => state.maintenanceCSV,
  historyMaintenanceCSV: state => state.historyMaintenanceCSV,
  termsOfService: state => state.termsOfService,
  footerLinkCSV: state => state.footerLinkCSV,
  status: state => state.status
}

// actions
const actions = {
  siteInfo ({ commit }) {
    external.get('/info/site_info.html')
      .then(response => {
        commit('setSiteInfo', response.data)
      })
      .catch(err => {
        commit('setSiteInfoError', err.response)
      })
  },
  termsService ({ commit }) {
    external.get('/terms_of_service/terms_of_service.html')
      .then(response => {
        commit('setTermsService', response.data)
      })
      .catch(err => {
        commit('setTermsServiceError', err.response)
      })
  },
  areaInfoCSV ({ commit }, areaId) {
    external.get('/info/area_info.csv')
      .then(response => {
        commit('setAreaInfoCSV', Papa.parse(response.data, {header: true}).data.find(item => parseInt(item.area_id, 10) === areaId).info)
      })
      .catch(err => {
        commit('setAreaInfoCSVError', err.response)
      })
  },
  maintenanceCSV ({ commit }, areaId) {
    external.get('/info/maintenance_info.csv')
      .then(response => {
        commit('setMaintenanceCSV', Papa.parse(response.data, {header: true}).data.find(item => parseInt(item.area_id, 10) === areaId).info)
      })
      .catch(err => {
        commit('setMaintenanceCSVError', err.response)
      })
  },
  historyMaintenanceCSV ({ commit }, areaId) {
    external.get('/info/history_info.csv')
      .then(response => {
        commit('setHistoryMaintenanceCSV', Papa.parse(response.data, {header: true}).data.find(item => parseInt(item.area_id, 10) === areaId).info)
      })
      .catch(err => {
        commit('setHistoryMaintenanceCSVError', err.response)
      })
  },
  footerLinkCSV ({ commit }) {
    external.get('/link/footer_link.csv')
      .then(response => {
        var lines = response.data.split('\r\n')
        lines = lines.filter(item => item !== '')
        var result = []
        var headers = lines[0].split(',')
        for (var i = 1; i < lines.length; i++) {
          var obj = {}
          var currentline = lines[i].split(',')
          for (var j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j]
          }
          result.push(obj)
        }
        commit('setFooterLinkCSV', result)
      })
      .catch(err => {
        commit('setFooterLinkCSVError', err.response)
      })
  }
}

// mutations
const mutations = {
  setSiteInfo (state, data) {
    if (/site_info/.test(data)) {
      state.siteInfo = data
    } else {
      state.siteInfo = ''
    }
  },
  setTermsService (state, data) {
    if (/terms-of-service/.test(data)) {
      state.termsOfService = data
    } else {
      state.termsOfService = ''
    }
  },
  setMaintenanceCSV (state, data) {
    state.maintenanceCSV = data
  },
  setAreaInfoCSV (state, data) {
    state.areaInfoCSV = data
  },
  setHistoryMaintenanceCSV (state, data) {
    state.historyMaintenanceCSV = data
  },
  setFooterLinkCSV (state, data) {
    state.footerLinkCSV = data
  },
  setSiteInfoError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = '接続失敗'
    }
    state.siteInfo = ''
  },
  setMaintenanceCSVError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = '接続失敗'
    }
    state.maintenanceCSV = ''
  },
  setAreaInfoCSVError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = '接続失敗'
    }
    state.areaInfoCSV = ''
  },
  setHistoryMaintenanceCSVError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = '接続失敗'
    }
    state.historyMaintenanceCSV = ''
  },
  setTermsServiceError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = '接続失敗'
    }
    state.termsOfService = ''
  },
  setFooterLinkCSVError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = '接続失敗'
    }
    state.footerLinkCSV = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/externalData.js